/* TGL cart v2: every add opens the drawer; live free-shipping top bar */
(function(){
  if(window.__tglCart)return;window.__tglCart=1;
  var TH=5000,_f=window.fetch.bind(window),busy=0;
  function money(c){return '$'+(c/100).toFixed(2)}
  function setBar(total){
    var b=document.getElementById('tgl-ship-top');if(!b)return;
    var t=parseInt(b.getAttribute('data-tgl-th'),10);if(t>0)TH=t;
    var left=TH-total,m=b.querySelector('.tgl-st__msg');
    b.classList.toggle('is-done',left<=0);
    m.innerHTML=left>0?'Only <strong>'+money(left)+'</strong> away from free shipping!':'Congrats! You\u2019ve unlocked free shipping!';
    var s=b.querySelector('.tgl-st__bar span');if(s)s.style.width=Math.min(100,Math.round(total*100/TH))+'%';
  }
  function syncBar(){_f('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){setBar(c.total_price)}).catch(function(){})}
  function drawer(){return document.querySelector('cart-drawer')}
  function openWith(sections,id){
    var d=drawer();if(!d||!d.renderContents){location.href='/cart';return}
    d.classList.remove('is-empty');
    if(d.setActiveElement)d.setActiveElement(document.activeElement||document.body);
    d.renderContents({sections:sections,id:id});
    document.body.classList.add('overflow-hidden');
  }
  function refreshDrawer(){
    var d=drawer();if(!d)return;
    _f('/?sections=cart-drawer,cart-icon-bubble').then(function(r){return r.json()}).then(function(s){openWith(s,null)});
  }
  window.TGLopenCart=function(){refreshDrawer()};
  /* 1) watch every cart mutation (quiz, apps, Dawn) to update the bar; open drawer for adds that did not render it */
  window.fetch=function(input,init){
    var url=typeof input==='string'?input:(input&&input.url)||'';
    var p=_f(input,init);
    if(/\/cart\/(add|change|update|clear)/.test(url)){
      var body=init&&init.body,hasSections=false;
      try{hasSections=(typeof body==='string'&&body.indexOf('sections')>-1)||(body instanceof FormData&&body.has('sections'))}catch(e){}
      p.then(function(r){if(!r.ok)return;syncBar();
        if(/\/cart\/add/.test(url)&&!hasSections&&!busy&&!window.__tglQuizOpen){setTimeout(refreshDrawer,50)}
      }).catch(function(){});
    }
    return p;
  };
  /* 2) plain forms posting to /cart/add (v7 cards, custom lid form, app buttons) */
  document.addEventListener('submit',function(e){
    var f=e.target;if(!f||!f.action||!/\/cart\/add/.test(f.getAttribute('action')||''))return;
    if(f.closest('product-form'))return; /* Dawn handles it */
    if(!drawer())return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]'),txt=btn&&btn.innerHTML;if(btn){btn.disabled=true;btn.setAttribute('aria-busy','true')}
    var fd=new FormData(f);if(e.submitter&&e.submitter.name)fd.append(e.submitter.name,e.submitter.value);
    fd.append('sections','cart-drawer,cart-icon-bubble');fd.append('sections_url',location.pathname);
    busy++;
    _f('/cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){return r.json()}).then(function(s){
        if(s.status){alert(s.description||s.message||'Could not add to cart');return}
        openWith(s.sections,s.id);syncBar();
      }).catch(function(){f.submit()}).finally(function(){busy--;if(btn){btn.disabled=false;btn.removeAttribute('aria-busy');btn.innerHTML=txt}});
  },true);
  /* 3) drawer suggestions */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-tgl-add]');if(!b)return;e.preventDefault();
    if(b.disabled)return;b.disabled=true;b.textContent='Adding';
    busy++;
    _f('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+b.dataset.tglAdd,quantity:1}],sections:'cart-drawer,cart-icon-bubble',sections_url:location.pathname})})
      .then(function(r){return r.json()}).then(function(s){
        if(s.status){b.textContent='Unavailable';return}
        if(drawer()&&b.closest('cart-drawer'))openWith(s.sections,null);else if(drawer()&&!document.getElementById('main-cart-items'))openWith(s.sections,null);else location.reload();
        syncBar();
      }).catch(function(){location.reload()}).finally(function(){busy--});
  });
  /* Dawn pubsub: quantity / remove in drawer or cart page */
  document.addEventListener('DOMContentLoaded',function(){
    if(window.subscribe&&window.PUB_SUB_EVENTS)subscribe(PUB_SUB_EVENTS.cartUpdate,function(){syncBar()});
  });
})();
